<form
  class="site-budget-amendment-modal max-h-180 w-[515px] space-y-5 overflow-x-scroll p-1"
  [formGroup]="createAmendmentForm"
>
  <div>
    <div class="mb-1 text-xs">Protocol Version</div>
    <ng-select
      class="select"
      placeholder="Select Version"
      [searchable]="true"
      [clearable]="false"
      bindValue="value"
      formControlName="protocolVersion"
      [items]="ref.data?.protocolVersionList ?? []"
      auxFormError
      required
    />
  </div>

  <div>
    <aux-site-budget-dropdown
      [hideOptionActions]="true"
      formControlName="siteBudgetVersion"
      label="Copy Site Invoiceables (optional)"
      [placeholder]="'Select version'"
      [selectedSiteId]="selectedSiteId()"
      [selectedProtocolVersion]="selectedProtocolVersion()"
      [tooltip]="disabledSiteBudgetTooltip"
      (optionsChanged)="siteBudgetOptionsChanged($event)"
    />
  </div>

  <aux-input
    #siteBudgetNameInput
    label="Site Budget Amendment Name"
    placeholder="Amendment Name / Version"
    formControlName="amendmentName"
    validators="required"
  />

  <div>
    <div class="mb-1 text-xs">Upload Site Contract Budget</div>
    <aux-file-manager
      #fileManager
      class="h-28 bg-aux-gray-light"
      [eager]="false"
      [metadata]="{}"
      [showSuccessOnUpload]="true"
    >
      <div class="flex items-center justify-center text-aux-gray-dark-100">
        <aux-icon name="Upload" />
        <div class="ml-3">
          <p class="text-lg">
            Drag & Drop Documents Here or
            <span
              class="text-aux-blue-link underline group-hover:text-aux-blue group-active:text-aux-blue-dark"
            >
              Browse
            </span>
          </p>
        </div>
      </div>
    </aux-file-manager>
  </div>

  @if (fileManager) {
    <aux-file-manager-uploaded-files [fileManager]="fileManager" />
  }

  <aux-input label="Reason for Amendment" formControlName="reason" [textArea]="true" [rows]="3" />
</form>
